var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tree',_vm._g(_vm._b({attrs:{"data":_vm.data,"load-data":_vm.loadDataCallback,"show-checkbox":""},on:{"on-check-change":_vm.handleCheckSelect}},'Tree',_vm.parent.$attrs,false),_vm.parent.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }